import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, Children, cloneElement, createElement } from 'react';
import cn from 'classnames';
import { useTabState, TabPanel, TabList, Tab as Tab$1 } from 'reakit/Tab';

var _excluded = ["active", "aria-label", "children", "className", "orientation"];
var Tabs = /*#__PURE__*/forwardRef(function Tabs(props, ref) {
  var active = props.active,
      ariaLabel = props['aria-label'],
      children = props.children,
      className = props.className,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var tab = useTabState({
    orientation: orientation,
    selectedId: active
  });
  var tabs = [];
  var panels = [];
  Children.toArray(children).filter(function (child) {
    return !!child;
  }) // skip falsey
  .forEach(function (child) {
    var _child$props = child.props,
        content = _child$props.children,
        id = _child$props.id,
        title = _child$props.title;
    var activeTabContent = id === tab.selectedId ? content : null;
    tabs.push(cloneElement(child, _extends({}, tab, {
      className: 'yt-tab',
      key: id,
      id: id,
      type: 'button'
    }), title));
    panels.push(createElement(TabPanel, Object.assign({}, tab, {
      className: "yt-tab__panel",
      children: activeTabContent,
      key: id,
      id: id + "-panel",
      tabIndex: -1
    })));
  });
  var classNames = cn('yt-tabs', "yt-tabs--" + orientation, className);
  return createElement("div", Object.assign({}, otherProps, {
    className: classNames
  }), createElement(TabList, Object.assign({}, tab, {
    "aria-label": ariaLabel,
    className: "yt-tab__list",
    ref: ref
  }), tabs), panels);
});
var Tab = /*#__PURE__*/forwardRef(function Tab(props, ref) {
  return createElement(Tab$1, Object.assign({}, props, {
    ref: ref
  }));
});
Tabs.Tab = Tab;

export { Tabs };
//# sourceMappingURL=Tabs.js.map
